import React from "react";

const AboutUs = () => {
  return (
  <section className="max-w-7xl mx-auto px-6 py-24 relative w-full overflow-hidden" id="about">
      {/* Accent Circles */}
      <div className="absolute -top-12 -left-12 w-40 h-40 bg-primary opacity-20 rounded-full -z-10"></div>
      <div className="absolute -bottom-12 -right-12 w-48 h-48 bg-secondary opacity-20 rounded-full -z-10"></div>

      {/* Headline */}
      <div className="text-center mb-16" data-aos="fade-down">
        <h2 className="text-5xl font-extrabold text-primary mb-4">About Us</h2>
        <p className="text-white text-xl max-w-3xl mx-auto">
          We’re not here to throw random content online — we build your brand with purpose.
        </p>
      </div>

      {/* Content Grid */}
      <div className="grid gap-12 grid-cols-1 items-center">
        {/* Text Column */}
        <div className="space-y-6">
          <p className="text-white text-lg" data-aos="fade-up" data-aos-delay="100">
            Our team combines strategy, design, editing, and marketing to deliver content that looks good, feels right, and actually performs.
          </p>
          <p className="text-white text-lg" data-aos="fade-up" data-aos-delay="200">
            Whether you’re a business or a personal brand, we help you{" "}
            <span className="text-primary font-semibold">show up, stand out, and scale online</span>.
          </p>

          {/* Highlights */}
          <div className="grid grid-cols-2 md:grid-cols-2 gap-4 mt-6">
            <div className="bg-background/50 border border-secondary rounded-xl p-4 flex items-center gap-3 hover:shadow-xl transition" data-aos="zoom-in" data-aos-delay="300">
              <span className="text-3xl">🎯</span>
              <span className="text-white font-medium">Strategy + Execution</span>
            </div>
            <div className="bg-background/50 border border-secondary rounded-xl p-4 flex items-center gap-3 hover:shadow-xl transition" data-aos="zoom-in" data-aos-delay="400">
              <span className="text-3xl">⚡</span>
              <span className="text-white font-medium">Fast & Reliable</span>
            </div>
            <div className="bg-background/50 border border-secondary rounded-xl p-4 flex items-center gap-3 hover:shadow-xl transition" data-aos="zoom-in" data-aos-delay="500">
              <span className="text-3xl">📈</span>
              <span className="text-white font-medium">Real Growth</span>
            </div>
            <div className="bg-background/50 border border-secondary rounded-xl p-4 flex items-center gap-3 hover:shadow-xl transition" data-aos="zoom-in" data-aos-delay="600">
              <span className="text-3xl">💡</span>
              <span className="text-white font-medium">Creative Design</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
